// Superscripts footnote marks (* † ‡ § ¶ °) wherever they sit, e.g. "Formulated to°††:".
export const supFootnoteMarkersHtml = (html: string): string =>
  html.replace(/[*†‡§¶°]+/g, (markers) => `<sup>${markers}</sup>`);
